import * as Proxy from './Proxy'

export default (function () {
    const baseUrl = "/paymentlobby/api/HostedPayment/";
    return {
        GetReversiblePaymentsFor(request) {
            var url = baseUrl + "GetReversiblePaymentsFor";
            return Proxy.Post(url, request);
        },
        ProcessPaymentReversal(request) {
            var url = baseUrl + "ProcessPaymentReversal";
            return Proxy.Post(url, request);
        }

    };
})()